module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/california-b7ee726107a0b2ce6c9067202dce520d.jpg";